import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useTenantVerificationMissing from "../hooks/useTenantVerificationMissing";
import { getAllPropertyTransactions } from "../services/krent.service";

interface Props {
  userId?: string;
}

export default function TenantVerificationBanner({ userId }: Props) {
  const [hasRentBooking, setHasRentBooking] = useState(false);

  useEffect(() => {
    if (!userId) return;
    const controller = new AbortController();

    getAllPropertyTransactions(userId, controller.signal, 1, "long lease")
      .then((res: any) => {
        const data: any[] = res?.data ?? [];
        setHasRentBooking(data.length > 0);
      })
      .catch(() => {
        if (!controller.signal.aborted) setHasRentBooking(false);
      });

    return () => controller.abort();
  }, [userId]);

  const missing = useTenantVerificationMissing(hasRentBooking);

  if (!missing) return null;

  return (
    <div
      className="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-3"
      role="status"
    >
      <div>
        <strong>Complete your Tenant Verification</strong>
        <div>Fill in your tenancy details to complete your verification.</div>
      </div>
      <Link
        className="btn btn-primary rounded-pill"
        to="/settings?tab=tenant-verification"
      >
        Complete verification
      </Link>
    </div>
  );
}
